import { useEffect, useRef, useCallback } from 'react';

const CHANNEL_NAME = 'fog-of-war-channel';

export function useBroadcastChannel(onMessage) {
  const channelRef = useRef(null);

  useEffect(() => {
    channelRef.current = new BroadcastChannel(CHANNEL_NAME);
    if (onMessage) {
      channelRef.current.onmessage = (event) => {
        onMessage(event.data);
      };
    }
    return () => {
      channelRef.current?.close();
    };
  }, [onMessage]);

  const postMessage = useCallback((data) => {
    channelRef.current?.postMessage(data);
  }, []);

  return { postMessage };
}
